var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{staticStyle:{"width":"100px","height":"100px","margin":"10px auto"}},[_vm._v("daping")])])}]

export { render, staticRenderFns }